import { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const fadeIn = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
const fadeOut = keyframes(["0%{opacity:1;}100%{opacity:0;}"]);
const Message = styled.div.withConfig({
  displayName: "LoadingMessages__Message"
})(["opacity:0;animation:", " 500ms forwards;"], props => props.animation === 'in' ? fadeIn : fadeOut);
const LoadingMessages = ({
  messages,
  isFinished = false,
  interval = 3000
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animationState, setAnimationState] = useState('in');
  useEffect(() => {
    const updateMessage = () => {
      setAnimationState('out');
      if (!isFinished) {
        setTimeout(() => {
          setCurrentIndex(prevIndex => (prevIndex + 1) % messages.length);
          setAnimationState('in');
        }, 500); // half of interval for fade-out, match this with CSS duration
      }
    };
    const timer = setInterval(updateMessage, interval);
    return () => {
      clearInterval(timer);
    };
  }, [messages, interval, isFinished]);
  return /*#__PURE__*/_jsx(Message, {
    animation: animationState,
    children: messages[currentIndex]
  });
};
export default LoadingMessages;